import { createAsyncThunk } from "@reduxjs/toolkit";
import checkoutApi from "services/checkoutApi";
import {
  PaginationProps,
  CheckoutItemDataProps,
  CheckoutItemsFulfilledPayload,
  ScheduledCheckoutItemsFulfilledPayload,
} from "./types.store";
import { setIsSpinnerVisible } from "../AppConfig/index.store";
import Axios from "axios";

const mapResponseToPayload = (
  response: unknown,
  defaultPagination: Partial<PaginationProps>,
): CheckoutItemsFulfilledPayload => {
  const items = Array.isArray(response)
    ? response
    : (response as { data?: CheckoutItemDataProps[] })?.data ?? [];
  const paginationFromResponse = Array.isArray(response)
    ? null
    : (response as { pagination?: Partial<PaginationProps> })?.pagination;
  return {
    data: items,
    pagination: {
      limit: paginationFromResponse?.limit ?? defaultPagination.limit ?? 10,
      offset: paginationFromResponse?.offset ?? defaultPagination.offset ?? 0,
      keyset: paginationFromResponse?.keyset ?? defaultPagination.keyset ?? "",
      count: paginationFromResponse?.count ?? defaultPagination.count ?? 0,
      totalCount:
        paginationFromResponse?.totalCount ?? defaultPagination.totalCount ?? 0,
    },
  };
};

export const handleGetCheckoutItemsRequest = createAsyncThunk<
  CheckoutItemsFulfilledPayload,
  { dealerId: string }
>(
  "getCheckoutItems",
  async ({ dealerId }: { dealerId: string }, { rejectWithValue, dispatch }) => {
    const queryParams = {
      limit: 50,
      statuses: "open",
    };
    try {
      dispatch(setIsSpinnerVisible(true));
      const { data } = await checkoutApi.get(
        `/v1/dealers/${dealerId}/sessions`,
        { params: queryParams },
      );
      return mapResponseToPayload(data, { limit: 50 });
    } catch (err) {
      if (Axios.isAxiosError(err) && err && err.response) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err);
    } finally {
      dispatch(setIsSpinnerVisible(false));
    }
  },
);

export const handleGetScheduledCheckoutItemsRequest = createAsyncThunk<
  ScheduledCheckoutItemsFulfilledPayload,
  { dealerId: string; pagination: Partial<PaginationProps> }
>(
  "getScheduledCheckoutItems",
  async (
    {
      dealerId,
      pagination,
    }: { dealerId: string; pagination: Partial<PaginationProps> },
    { rejectWithValue, dispatch },
  ) => {
    const queryParams = {
      limit: pagination.limit ?? 10,
      keyset: pagination.keyset ?? undefined,
      statuses: "scheduled",
    };

    try {
      dispatch(setIsSpinnerVisible(true));
      const { data } = await checkoutApi.get(
        `/v1/dealers/${dealerId}/sessions`,
        {
          params: queryParams,
        },
      );
      return mapResponseToPayload(data, {
        limit: pagination.limit,
        keyset: pagination.keyset ?? undefined,
      });
    } catch (err) {
      if (Axios.isAxiosError(err) && err && err.response) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err);
    } finally {
      dispatch(setIsSpinnerVisible(false));
    }
  },
);
